import { RetrievalMethod } from '../../profiles/constants';
import type { PatientStatus } from './patient-entity';

// Standalone request type strings for reuse (avoid magic strings)
export const REQUEST_TYPE_STANDALONE_FACESHEET = 'standalone_facesheet';
export const REQUEST_TYPE_STANDALONE_RECORD_UPLOAD = 'standalone_record_upload';

export type PatientRequest = {
  crrId?: string;
  requestType?: 'crr' | 'standalone_facesheet' | 'standalone_record_upload';
  requestDate: string;
  services: Array<{
    id: string | number;
    service: string;
    retrievalMethod: RetrievalMethod;
    status: string;
    statusGroup: string;
    statusText: string;
    lastModified: string;
  }>;
};

type BaseService = {
  status: string;
  statusGroup: string;
  statusText: string;
};

export type ProviderFacilityService = BaseService & {
  id: number;
  providerName?: string;
  facilityName?: string;
  service?: string;
  practiceName?: string;
  serviceStartDate: Date | string;
  serviceEndDate: Date | string;
  specialty?: string;
  address?: {
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
  };
  phoneNumber?: string;
  faxNumber?: string;
  recordsRequested: string;
};

export type HIEService = BaseService & {
  alternativePostalCodes?: string[];
};

export type MedicationsService = BaseService;

export type RecordUploadService = BaseService & {
  fileName: string;
};

export type FacesheetService = BaseService & {
  id: string;
  name: string;
  expedited: boolean;
};

export type RequestDetails = {
  requestId: string;
  requestFrom?: string;
  releasedTo?: string;
  requestDate: Date | string;
  dateNeededBy?: Date | string;
  referenceId?: string;
  retrieveFrom?: ProviderFacilityService[];
  hie?: HIEService[];
  medications?: MedicationsService;
  recordUpload?: RecordUploadService;
  facesheets?: FacesheetService[];
  // Extended fields from API response
  notificationEmails?: string[];
  previousDocumentIds?: string[];
};

export type ServiceItem = {
  id: string;
  name: string;
  status: string;
  statusGroup: string;
  statusText: string;
  lastModified: string;
  showActions: boolean;
};

// Patient Status Arrays
export const RETRIEVAL_STATUSES: PatientStatus[] = [
  'OPEN',
  'PROCESSING',
  'ACTION REQUIRED',
  'COMPLETED',
  'CANCELLED',
  'CLOSED',
];

export const UPLOAD_STATUSES: PatientStatus[] = [
  'RU_OPEN',
  'RU_PROCESSING',
  'RU_COMPLETED',
];

export const FACESHEET_STATUSES: PatientStatus[] = [
  'FS_PENDING',
  'FS_PROCESSING',
  'FS_COMPLETE',
  'FS_CLOSED',
];
